/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Form , Col , Row , Modal , Button} from 'react-bootstrap'

import FieldGroup from '../FieldGroup.js';
import Translation from '../../store/internationalization-store.js'
import Checkbox from '../checkbox.js';

function enableTab(id) {
    var el = document.getElementById(id);
    el.onkeydown = function(e) {
        if (e.keyCode === 9) { // tab was pressed

            // get caret position/selection
            var val = this.value,
                start = this.selectionStart,
                end = this.selectionEnd;

            // set textarea value to: text before caret + tab + text after caret
            this.value = val.substring(0, start) + '\t' + val.substring(end);

            // put caret at right position again
            this.selectionStart = this.selectionEnd = start + 1;

            // prevent the focus lose
            return false;

        }
    };
}

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            value:this.props.value || "",
            preg:'tab'
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || "",
            preg:'tab'
        };

        if(this.props.show)
        {
            setTimeout(function(){enableTab('tab-enabled')} , 1000)
           // enableTab('tab-enabled');
        }
    }

    componentDidMount()
    {
       //enableTab('tab-enabled');
    }

    onSave(){

        let vocabs = this.format(this.state.students)
        if(this.props.onImport) this.props.onImport(vocabs)
    }


    format(string){

        let proccessed = [];
        let pairs = String(string).split(/\r?\n/);


        for(var idx = 0 ; idx < pairs.length; idx++ )
        {

            switch(this.state.preg)
            {
                case  'tab' :
                    var vocabs = pairs[idx].split(/\t/);
                    break;
                default  :
                    var vocabs = pairs[idx].split(',');
                    break;
            }

            if(!vocabs || vocabs.length < 2) continue;

            proccessed.push({
                learning:{text:vocabs[0]},
                support:{text:vocabs[1]}
            })
        }


        return proccessed;

    }


    insertTab(o, e)
    {
        var kC = e.keyCode ? e.keyCode : e.charCode ? e.charCode : e.which;
        if (kC == 9 && !e.shiftKey && !e.ctrlKey && !e.altKey)
        {
            var oS = o.scrollTop;
            if (o.setSelectionRange)
            {
                var sS = o.selectionStart;
                var sE = o.selectionEnd;
                o.value = o.value.substring(0, sS) + "\t" + o.value.substr(sE);
                o.setSelectionRange(sS + 1, sS + 1);
                o.focus();
            }
            else if (o.createTextRange)
            {
                document.selection.createRange().text = "\t";
                e.returnValue = false;
            }
            o.scrollTop = oS;
            if (e.preventDefault)
            {
                e.preventDefault();
            }
            return false;
        }
        return true;
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(12640 , 'Import Vocabulary')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <b>{Translation.get(12641 , 'Copy and paste your data here (from Word, Excel, Google Docs etc)')}</b>
                            <div >
                                <FieldGroup id="tab-enabled" style={{"resize":"none"}}  as="textarea" rows="6" onChange={(event)=>{this.setState({saved:false, students:event.target.value});}} value={this.state.students} label={Translation.get(17328 , "Paste or type your vocabulary list in here, one vocab pair per line (Learning language first)")}/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <b>{Translation.get(12642 , 'Between Learning and Support')}</b>
                            <Form>
                                <Checkbox onChange={(event)=>{ this.setState({preg:event.target.checked == true ? 'tab' : 'comma'})}} checked={this.state.preg == "tab"}  label={Translation.get(12643 , 'Tab')} type={'radio'} />

                                <Checkbox onChange={(event)=>{ this.setState({preg:event.target.checked == true ? 'comma' : 'tab'})}}  checked={this.state.preg != "tab"}  label={Translation.get(12644 , 'Comma')} type={'radio'}  />
                            </Form>
                        </Col>
                        <Col md={6}>

                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='danger' onClick={this.props.onHide}>{Translation.get(41 , 'Cancel')}</Button> <Button varient={'danger'} onClick={this.onSave.bind(this)}>{Translation.get(12763 , 'Import')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}